import { SimpleDocCommand } from '../../apps/DocsApp/commands/v5/types';
import { StandardToolResult, createSuccessResult, createErrorResult } from '../../types/standardToolResults';
import { CommandExecutionContext } from '../../types/commands';
import { API_BASE_URL } from '../../api/config';
import fetchService from '../../services/fetchService';
import { schemaToParameters } from '../../utils/schemaToParameters';

export const send_sms: SimpleDocCommand = {
  id: 'send_sms',
  logicalName: 'send_sms',
  version: 'v1',

  description: 'Send an SMS message to a phone number.',

  schema: {
    parameters: schemaToParameters({
      type: 'object',
      properties: {
        message: {
          type: 'string',
          description: 'The SMS message to send. Keep brief and plain-text (no markdown, under 300 chars).',
        },
      },
      required: ['message'],
    }),
  },

  handler: async (params: any, _context: CommandExecutionContext): Promise<StandardToolResult> => {
    const { message } = params;

    if (!message || !message.trim()) {
      return createErrorResult('Missing message', 'message is required to send an SMS', 'validation');
    }

    try {
      const response = await fetchService(`${API_BASE_URL}/twilio/send-sms`, {
        method: 'POST',
        body: JSON.stringify({ message: message.trim() }),
      });

      return createSuccessResult('SMS sent', {
        to_number: response.to_number,
        sid: response.sid,
      });
    } catch (error: any) {
      const msg = error?.message || 'Unknown error';

      if (msg.includes('400') || msg.includes('No SMS phone number')) {
        return createErrorResult(
          'No phone number registered',
          'The user has not added a phone number yet. Ask them to go to Settings → Notifications to add one.',
          'validation',
        );
      }

      if (msg.includes('503') || msg.includes('not configured')) {
        return createErrorResult(
          'SMS not available',
          'SMS is not configured on this server.',
          'execution',
        );
      }

      return createErrorResult('SMS send failed', msg, 'execution');
    }
  },
};
